import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { Row, Col, Form, Button, Modal, Spinner, Tab, Nav, Card } from 'react-bootstrap';
import { TableDocument, Calendar } from 'iconsax-react';
import Select from 'react-select';
import { usePageTitle } from "../../../../layouts/PageHeaderExtra";
import { motivoPrenotazioniFuture, useStatoNelTitolo } from "../../../../components/Util/StatoProdotto";
import MyApiClient from '../../../../../api-client/MyApiClient';
import { sports } from '../../../../components/Util/enum';
import { useProfile } from '../../../../../hooks/useProfile';
import DisponibilitaImpianto from '../../../../components/Impianti/disponibilitaImpianto';
import UserVenuesTable from '../../../struttura/booking/userFacilities/index';
import { VAT_OPTIONS, findVatOption } from '../../../../components/Util/vatOptions';

export const AdminFacilitiesEdit = () => {

    const { id } = useParams();

    const { profile: profileData } = useProfile({ 
        autoFetch: true 
    });

	const [loadingShowed, setLoadingShowed] = useState(false);

    const [enabledSports, setEnabledSports] = useState([]);

    // Stato per gestire i metodi di pagamento abilitati
    const [paymentMethods, setPaymentMethods] = useState({
        stripe_enabled: false,
        bank_transfer_enabled: false
    });

    const [showingSociOptions, setShowingSociOptions] = useState(false);
    const [showingTesseratiOptions, setShowingTesseratiOptions] = useState(false);

    const [formData, setFormData] = useState({
        id: '',
        name: '', 
        description: '',
        sportType: '',
        multiCourse: false,
        showToCustomers: false,
        // Campi per prezzi e disponibilità
        payable_stripe: false,
        payable_bank: false,
        payable_in_club: false,
        standard_price: 0,
        member_price: 0,
        federated_price: 0,
        fitcoin_cashback: 0
    });

    // Titolo della pagina = nome dell'impianto, appena caricato.
    usePageTitle(formData?.name);
    // Stato (Attivo = visibile e acquistabile dai clienti) nella tendina accanto al titolo: si salva subito
    // (regola SUI). Il super admin cambia solo questo dell'impianto; niente Non attivo con prenotazioni future.
    const cambiaStato = async (attiva) => {
        const tokenDetailsString = sessionStorage.getItem('userDetails');
        if (!tokenDetailsString) return { annullato: true };
        const token = JSON.parse(tokenDetailsString).idToken;
        const apiClient = new MyApiClient();
        if (!attiva) {
            const prenotazioni = await apiClient.getUserBookingVenues(token, formData.id);
            if (prenotazioni?.error) return { error: prenotazioni.error };
            const motivo = motivoPrenotazioniFuture(prenotazioni, 'l’impianto');
            if (motivo) return { error: motivo };
        }
        const risposta = await apiClient.updateVenue(token, formData.id, { showToCustomers: attiva });
        if (risposta?.error) return { error: risposta.error };
        setFormData(prev => ({ ...prev, showToCustomers: attiva }));
        return {};
    };
    useStatoNelTitolo({
        visibile: !!formData?.id,
        attivo: !!formData?.showToCustomers && formData.showToCustomers !== 'false',
        onCambia: cambiaStato,
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prevState => ({
            ...prevState,
            [name]: value
        }));
    };

    // Opzioni per i campi boolean
    const optionsBoolean = [
        { value: true, label: 'Sì' },
        { value: false, label: 'No' }
    ];

    const handleSelectChange = (selectedOption, name) => {
        const selectedValue = selectedOption?.value || '';
        setFormData(prev => ({
            ...prev,
            [name]: selectedValue,
        }));
    };

    const handleSelectChangeBoolean = (selectedOption, name) => {
        setFormData(prevData => ({
            ...prevData,
            [name]: selectedOption.value
        }));
    };

	const tabData = [
		{
			name: "Informazioni",
			icon: <TableDocument size='18' variant='Bulk' />,
			content: (
				<Card>
					<Card.Header><h4 className="card-title">Modifica Impianto</h4></Card.Header>
					<Card.Body>
						<Form id="facilitiesForm">
							<Row>
								<Col md={6}>
									<Form.Group className="mb-3">
										<Form.Label>Nome Impianto *</Form.Label>
										<Form.Control
											disabled
                                            style={{color: 'rgba(108,117,125,0.6)', backgroundColor: '#f2f2f2', paddingLeft: "15px", fontWeight: "normal" }}
											className="mt-2"
											type="text"
											name="name"
											value={formData.name}
											onChange={handleChange}
											placeholder="Inserisci il nome dell'impianto"
											required
										/>
									</Form.Group>
								</Col>
								<Col md={6}>
									<Form.Group className="mb-3">
										<Form.Label>Sport *</Form.Label>
										<Select
											isDisabled
											name="sportType"
											value={enabledSports.find(option => option.value === formData.sportType)}
											onChange={(selectedOption) => handleSelectChange(selectedOption, "sportType")}
											options={enabledSports}
											placeholder="Seleziona sport"
											style={{
												lineHeight: "40px",
												color: "#fd7e14",
												paddingLeft: " 15px",
											}}
										/>
									</Form.Group>
								</Col>
							</Row>
							<Row>
								<Col md={6}>
									<Form.Group className="mb-3">
										<Form.Label>Multi Corso</Form.Label>
										<Select
											isDisabled
											name="multiCourse"
											value={{ value: formData.multiCourse, label: formData.multiCourse ? 'Sì' : 'No' }}
											options={[
												{ value: true, label: 'Sì' },
												{ value: false, label: 'No' }
											]}
											placeholder="Seleziona opzione"
										/>
									</Form.Group>
								</Col>
							</Row>
							<Row>
								<Col md={12}>
									<Form.Group className="mb-3">
										<Form.Label>Descrizione</Form.Label>
										<Form.Control
											disabled
                                            style={{color: 'rgba(108,117,125,0.6)', backgroundColor: '#f2f2f2', paddingLeft: "15px", fontWeight: "normal" }}
											className="mt-2"
											as="textarea"
											rows={3}
											name="description"
											value={formData.description}
											onChange={handleChange}
											placeholder="Inserisci una descrizione dell'impianto"
										/>
									</Form.Group>
								</Col>
							</Row>
							<div className="d-flex justify-content-end gap-4">
								<Button 
									variant="secondary" 
									className="btn btn-dark light"
									as={Link} 
									to="/superadmin/booking/facilities"
								>
									Indietro
								</Button>
								{/*<Button 
									variant="primary" 
									className="btn btn-primary"
									onClick={handleSaveClick}
									disabled={loadingShowed}
								>
									Salva Modifiche
								</Button>*/}
							</div>
						</Form>
					</Card.Body>
				</Card>
			),
		},
		{
			name: "Disponibilità",
			icon: <Calendar size='18' variant='Bulk' />,
			content: <DisponibilitaImpianto venueId={id} readonly={true} />,
		},
		{
			name: "Prezzi",
			icon: <i className="fas fa-dollar-sign me-2"></i>,
			content: (
				<Card>
					<Card.Header><h4 className="card-title">Prezzi</h4></Card.Header>
					<Card.Body>
						<Form>
							<Row>
								<Col md={12}>
									<h5 className="mb-3">Metodi di Pagamento</h5>
								</Col>
							</Row>
							<Row>
								<Col md={6}>
									<Form.Group className="mb-3">
										<Form.Label>Pagabile in Struttura</Form.Label>
										<Select
											isDisabled
											name="payable_in_club"
											value={optionsBoolean.find(option => option.value === formData.payable_in_club)}
											options={optionsBoolean}
											placeholder="Seleziona opzione"
										/>
									</Form.Group>
								</Col>
								{paymentMethods.stripe_enabled && (
								<Col md={6}>
									<Form.Group className="mb-3">
										<Form.Label>Pagabile con Stripe</Form.Label>
										<Select
											isDisabled
											name="payable_stripe"
											value={optionsBoolean.find(option => option.value === formData.payable_stripe)}
											options={optionsBoolean}
											placeholder="Seleziona opzione"
										/>
									</Form.Group>
								</Col>
								)}
								{paymentMethods.bank_transfer_enabled && (
								<Col md={6}>
									<Form.Group className="mb-3">
										<Form.Label>Pagabile con Bonifico</Form.Label>
										<Select
											isDisabled
											name="payable_bank"
											value={optionsBoolean.find(option => option.value === formData.payable_bank)}
											options={optionsBoolean}
											placeholder="Seleziona opzione"
										/>
									</Form.Group>
								</Col>
								)}
							</Row>
							
							<Row>
								<Col md={12}>
									<h5 className="mb-3 mt-4">Prezzi orari</h5>
								</Col>
							</Row>
							<Row>
								<Col md={6}>
									<Form.Group className="mb-3">
										<Form.Label>Prezzo Standard</Form.Label>
										<Form.Control
											disabled
											style={{color: 'rgba(108,117,125,0.6)', backgroundColor: '#f2f2f2', paddingLeft: "15px", fontWeight: "normal" }}
											type="number"
											min="0"
											step="0.01"
											name="standard_price"
											value={formData.standard_price}
											placeholder="Inserisci il prezzo standard"
										/>
									</Form.Group>
								</Col>
								<Col md={6}>
									<Form.Group className="mb-3">
										<Form.Label>IVA</Form.Label>
										<Select
											isDisabled
											value={findVatOption(formData)}
											options={VAT_OPTIONS}
										/>
									</Form.Group>
								</Col>
								{showingSociOptions && (
								<Col md={6}>
									<Form.Group className="mb-3">
										<Form.Label>Prezzo per soci / tesserati</Form.Label>
										<Form.Control
											disabled
											style={{color: 'rgba(108,117,125,0.6)', backgroundColor: '#f2f2f2', paddingLeft: "15px", fontWeight: "normal" }}
											type="number"
											min="0"
											step="0.01"
											name="federated_price"
											value={formData.federated_price}
											placeholder="Inserisci il prezzo per soci / tesserati"
										/>
									</Form.Group>
								</Col>
								)}
								<Col md={6}>
									<Form.Group className="mb-3">
										<Form.Label>Cashback FitCoin</Form.Label>
										<Form.Control
											disabled
											style={{color: 'rgba(108,117,125,0.6)', backgroundColor: '#f2f2f2', paddingLeft: "15px", fontWeight: "normal" }}
											type="number"
											min="0"
											step="0.01"
											name="fitcoin_cashback"
											value={formData.fitcoin_cashback}
											placeholder="Inserisci il cashback in FitCoin"
										/>
									</Form.Group>
								</Col>
							</Row>
						</Form>
					</Card.Body>
				</Card>
			),
		},
		/*
		{
			name: "Acquisti",
			icon: <i className="fas fa-shopping-cart me-2"></i>,
			content: <UserVenuesTable venue_id={id} />,
		}
		*/
	];

    useEffect(() => {
        const fetchData = async () => {
            try {
                const tokenDetailsString = sessionStorage.getItem('userDetails');
                if (tokenDetailsString) {
                    const tokenDetails = JSON.parse(tokenDetailsString);
                    const token = tokenDetails.idToken;
                    const apiClient = new MyApiClient();

                    setLoadingShowed(true);
                    const venues = await apiClient.getVenues(token);
                    setLoadingShowed(false);

                    const venue = venues.find(v => v.id === id);
                    if(venue) {
                        const elementFormData = {
                            id: venue.id,
                            name: venue.name, 
                            description: venue.description,
                            sportType: venue.sportType,
                            multiCourse: venue.multiCourse || false,
                            showToCustomers: venue.showToCustomers || false,
                            // Campi per prezzi e disponibilità
                            payable_stripe: venue.payable_stripe || false,
                            payable_bank: venue.payable_bank || false,
                            payable_in_club: venue.payable_in_club || false,
                            standard_price: venue.standard_price || 0,
                            vat_rate: venue.vat_rate,
                            vat_nature: venue.vat_nature,
                            iva_5_percent: venue.iva_5_percent,
                            member_price: venue.member_price || 0,
                            federated_price: venue.federated_price || 0,
                            fitcoin_cashback: venue.fitcoin_cashback || 0
                        };
                        setFormData(elementFormData);
                    }
                }
            } catch (error) {
                console.error("Error fetching data:", error);
                setLoadingShowed(false);
            }
        };

        fetchData();
    }, [id]);

    useEffect(() => {
        setEnabledSports(sports);
    }, [profileData]);

	return (
		<>
			<Modal className="fade" show={loadingShowed} centered>
				<Modal.Body className="text-center">
					<Spinner animation="border" role="status">
						<span className="sr-only">Loading...</span>
					</Spinner>
					<div>Caricamento in corso...</div>
				</Modal.Body>
			</Modal>

			<div className="custom-tab-1">
				<Tab.Container defaultActiveKey={tabData[0].name.toLowerCase()}>
					<Nav as="ul" className="nav-tabs" style={{ border: 'none' }}>
						{tabData.map((data, i) => (
							<Nav.Item as="li" key={i} className="tabMenu">
								<Nav.Link eventKey={data.name.toLowerCase()}>
									{data.name}
								</Nav.Link>
							</Nav.Item>
						))}
					</Nav>
					<Row className="align-items-start mt-4">
						<div className="col-xl-9">
							<Tab.Content>
								{tabData.map((data, i) => (
									<Tab.Pane eventKey={data.name.toLowerCase()} key={i}>
										{data.content}
									</Tab.Pane>
								))}
							</Tab.Content>
						</div>
						<div className="col-xl-3">
							<Card>
								<Card.Body className="text-center">
									<h4 className="text-start mb-0 mt-4 text-warning">{formData.name}</h4>
									<p className="text-start mt-0 pt-0">Impianto Sportivo</p>
									<p className="text-start mt-2">{formData.description}</p>
								</Card.Body>
							</Card>
						</div>
					</Row>
				</Tab.Container>
			</div>
		</>
	);
};

export default AdminFacilitiesEdit;